/* eslint-disable no-undef */

import log from 'common/services/logging/loggers';
import Util from 'common/services/util/-RFC.util';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$window'];

class CartIframeController {

    constructor($scope, $window) {

        this.$scope = $scope;
        this.$window = $window;

        const browser = $window.browserName.toLowerCase() + $window.browserVersion;

        if (typeof Cleverbridge !== 'undefined' && browser !== 'ie11') {

            // Set fallback iframe size
            let iframeWidth = (750 - 2); // 2px for the border
            const iframeHeight = (700 - 2); // 2px for the border

            if (this.$scope.getmodalwidth && typeof this.$scope.getmodalwidth === 'function') {

                iframeWidth = this.$scope.getmodalwidth();

            }

            const storeDomain = Util.deepFind(CWCONFIG, 'addPayment.eShopDomain') || 'e-shop.avira.com';
            log.debug('storeDomain', storeDomain);

            Cleverbridge.init('cbFrame', {
                debug: true,
                storeDomain,
                iframe: {
                    width: iframeWidth,
                    height: iframeHeight,
                },
            });

            // Resize the iframe inside modal
            angular.element(window).bind('resize', () => {

                iframeWidth = this.$scope.getmodalwidth();
                Cleverbridge.setWidth(iframeWidth);

            });

            let checkoutUrl = this.$scope.url;

            if (localStorage.getItem('theme') === 'dark') {

                checkoutUrl += '&x-theme=dark';

            }

            Cleverbridge.on('frameready', () => {

                log.debug('CB event frameready');

                if (this.$scope.iframeready && typeof this.$scope.iframeready === 'function') {

                    this.$scope.iframeready();

                }

            });

            Cleverbridge.on('frameloaded', () => {

                log.debug('CB event frameloaded');

                if (this.$scope.frameloaded && typeof this.$scope.frameloaded === 'function') {

                    this.$scope.frameloaded();

                }

            });

            Cleverbridge.on('purchasecomplete', () => {

                log.debug('CB event purchasecomplete');

                if (this.$scope.purchasecomplete && typeof this.$scope.purchasecomplete === 'function') {

                    const transactionId = Cleverbridge.getPurchaseId();
                    this.$scope.purchasecomplete(transactionId);

                }

            });

            Cleverbridge.on('error', (eventData) => {

                log.error('CB IFRAME ERROR', eventData);

                if (this.$scope.url) {

                    // Fallback open the shop url in a new browser tab
                    this.$window.open(this.$scope.url, '_blank');

                    if (this.$scope.error && typeof this.$scope.error === 'function') {

                        this.$scope.error(eventData);

                    }

                }

                Cleverbridge.resetCallbacks();

            });

            Cleverbridge.handleCTAClick(checkoutUrl);

        } else {

            if (this.$scope.error && typeof this.$scope.error === 'function') {

                this.$scope.error({ code: 0, message: 'Cleverbridge library not loaded' });

            }

            log.error('CB LIB ERROR', { statusCode: 0, message: 'Cleverbridge library not loaded' });

            // Fallback open the shop url in a new browser tab
            $window.open(this.$scope.url, '_blank');

        }

        $scope.$on('$destroy', () => {

            // Disable the callbacks execution after the modal was closed
            if (typeof Cleverbridge !== 'undefined') {

                Cleverbridge.resetCallbacks();
                Cleverbridge.reset();

            }

        });

    }

}

class CartIframeDirective {

    constructor() {

        this.template = require('./cart-iframe.html');
        this.restrict = 'EA';
        this.replace = true;

        this.scope = {
            width: '=',
            height: '=',
            url: '=',
            error: '=',
            iframeready: '=',
            purchasecomplete: '=',
            getmodalwidth: '=',
            frameloaded: '=',
        };

        _controllerDependencies
            .push(($scope, $window) => new CartIframeController($scope, $window));

        this.controller = _controllerDependencies;
        this.controllerAs = 'cartIframeCtrl';

    }

}

_directiveDependencies.push(() => new CartIframeDirective());


angular.module('directives')
    .directive('cartIframe', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/cart-iframe/cart-iframe.js